// TODO: anything imported here should be moved to shared modules (eg all campaign agents)
import {copilot, users as usersShared} from '@cl/shared';
import campaignAnalyticsAgent from 'common/src/modules/analytics/copilot/agents/campaignAnalyticsAgent/campaignAnalyticsAgent';
import campaignSetupAgent from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/campaignSetupAgent';
import excelToCampaignAgent from 'common/src/modules/campaigns/copilot/agents/excelToCampaignAgent/excelToCampaignAgent';
import strategyAgent from 'common/src/modules/campaigns/copilot/agents/strategyAgent/strategyAgent';
import fetchCampaigns from 'common/src/modules/campaigns/store/campaignsLibrary/thunks/fetchCampaigns';
import {FeatureFlagKey} from 'common/src/modules/featureFlags/featureFlags.types';
import isFlagEnabled from 'common/src/modules/featureFlags/utils/isFlagEnabled';
import {doesUserHaveRole} from 'common/src/modules/roles/utils/doesUserHaveRole';
import campaignAnalyticsSkill from 'common/src/modules/shared/copilot/skills/definitions/campaignAnalyticsSkill';
import campaignSetupSkill from 'common/src/modules/shared/copilot/skills/definitions/campaignSetupSkill/campaignSetupSkill';
import excelToCampaignSkill from 'common/src/modules/shared/copilot/skills/definitions/excelToCampaignSkill';
import socialCampaignSetupSkill from 'common/src/modules/shared/copilot/skills/definitions/socialCampaignSetupSkill';
import {registerSkill} from 'common/src/modules/shared/copilot/skills/skillRegistry';
import socialCampaignSetupAgent from 'common/src/modules/social/copilot/agents/socialCampaignSetupAgent/socialCampaignSetupAgent';
import {RoleTypeName} from 'common/src/modules/users/users.types';
import {CLStore} from 'common/src/redux/store';

async function initializeCampaignsAgents(store: CLStore) {
  if (store.getState().campaignsLibrary.campaigns.length === 0) {
    await store.dispatch(fetchCampaigns());
  }

  const isSkillsMode = isFlagEnabled(FeatureFlagKey.EnableCopilotSkills);

  if (isFlagEnabled(FeatureFlagKey.EnableCopilotCampaignsManagerAgent)) {
    const userHasCampaignsWriteRole = doesUserHaveRole(
      usersShared.userSubject.data,
      RoleTypeName.CampaignsWrite,
    );

    if (
      isFlagEnabled(FeatureFlagKey.EnableCopilotExcelToCampaignAgent) &&
      userHasCampaignsWriteRole
    ) {
      if (!isSkillsMode) {
        copilot.registerAgent(excelToCampaignAgent(store));
      }

      registerSkill(excelToCampaignSkill(store));
    }

    if (isFlagEnabled(FeatureFlagKey.EnableCopilotCampaignAnalyticsAgent)) {
      if (!isSkillsMode) {
        copilot.registerAgent(campaignAnalyticsAgent(store));
      }

      registerSkill(campaignAnalyticsSkill(store));
    }

    if (isFlagEnabled(FeatureFlagKey.EnableCopilotCampaignSetupAgent)) {
      if (!isSkillsMode) {
        copilot.registerAgent(campaignSetupAgent(store));
      }

      registerSkill(campaignSetupSkill(store));
    }

    if (isFlagEnabled(FeatureFlagKey.EnableCopilotSocialCampaignSetupAgent)) {
      if (!isSkillsMode) {
        copilot.registerAgent(socialCampaignSetupAgent(store));
      }

      registerSkill(socialCampaignSetupSkill(store));
    }

    if (isFlagEnabled(FeatureFlagKey.EnableCopilotBriefAndStrategyAgents)) {
      if (!isSkillsMode) {
        copilot.registerAgent(strategyAgent(store));
      }
    }
  }
}

export default initializeCampaignsAgents;
